import React from 'react';
import PropTypes from 'prop-types';

import SeparatorLine from '@components/SeparatorLine';
import { ArrowRight } from '@components/Icons';

import Container from '../components/Container';
import Content from '../components/Content';
import TextContainer from '../components/TextContainer';
import Label from '../components/Label';
import Caption from '../components/Caption';
import Text from '../components/Text';
import SeparatorContainer from '../components/SeparatorContainer';

function Simple({
  label,
  text,
  caption,
  icon,
  onClick,
  onContinue,
  elementId,
}) {
  return (
    <div id={elementId}>
      <Container>
        <Content>
          {icon}
          <TextContainer onClick={onClick}>
            <div>
              <Label>{label}</Label>
              <Text>{text}</Text>
            </div>
            <div>
              <Caption>{caption}</Caption>
            </div>
          </TextContainer>
        </Content>
        {onContinue && <ArrowRight size="medium" onClick={onContinue} />}
      </Container>
      <SeparatorContainer>
        <SeparatorLine />
      </SeparatorContainer>
    </div>
  );
}

Simple.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
  caption: PropTypes.string,
  icon: PropTypes.node,
  onContinue: PropTypes.func,
  onClick: PropTypes.func,
  elementId: PropTypes.string,
};

Simple.defaultProps = {
  onClick: () => {},
};

export default Simple;
